import React from "react";
import styled from "styled-components";
import { ProductConsumer } from "../context/context";
import { SegmentedControl } from 'segmented-control-react';




export default function BurgerSizeChoice() {
  
	return (
		<ProductConsumer>
			{(value) => {
                const{burgerSegments,selected,handleChangeSize}=value;
               
				return (
					<PizzaSizeChoiceWrapper>
					  <SegmentedControl
            segments={burgerSegments}
            selected={selected} 
            variant="base"
            onChangeSegment={handleChangeSize}           
        />  
					</PizzaSizeChoiceWrapper>
				);
			}}
		</ProductConsumer>
	);
}

const PizzaSizeChoiceWrapper = styled.div`

`;
